import { Theme } from '@mui/material'

const classes = {
  contentContainer: (isMobile: boolean) => ({
    flexDirection: 'column',
    gap: 2,
    marginTop: isMobile ? 2 : 0,
  }),
  descriptionText: (theme: Theme) => ({
    color: theme.palette.text.secondary,
  }),
  moreInfoLink: {
    fontSize: 'inherit',
    fontWeight: '500',
  },
  logosContainer: {
    gap: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
}

export default classes
